<template>
  <!-- <img alt="Vue logo" src="https://vuejs.org/images/logo.png" />
    -->
  <!-- <HelloWorld msg="Welcome to Your Vue.js App - Simon" /> -->
  <!-- <link rel="stylesheet" href="styles.css" /> -->
  <!-- <script defer type="module" src="script.js"></script> -->
  <!-- <script defer type="module" src="utils.js"></script> -->
  <!-- <script defer src="csv.min.js"></script> -->
  <!-- {{ screenWidth }} -->
  <!-- {{ currentMode }} -->
  <!-- <link href="https://brcresultsapp.web.app/brc-results.css" rel="stylesheet"> -->
  <div id="results-app" :class="containerClass">
    <div id="loading" v-show="isLoading">
      <!-- <div class="loader-06"></div> -->
      <div class="loader-running">
        <div class="runner">
          <img src="https://brcresultsapp.web.app/images/running.gif" />
          <span>&nbsp;</span>
        </div>
        
      </div>
    </div>
    <div class="phone">
          <!-- <img src="https://brcresultsapp.web.app/images/phone-rotate.png" /> -->
          <img src="https://brcresultsapp.web.app/images/phone-rotate.png" />
          {{ rotateMessage }}
    </div>
    <nav id="tabs">
      <span
        id="tab-leaderboard"
        :class="selectedTabClass(0)"
        @click="leaderboard"
        >Leaderboard</span
      >
      <!--
          <a id="tab-member" href="#">Member</a>
        -->
      <span v-if="monthsLimit[1] > 0" id="tab-month" :class="selectedTabClass(1)" @click="races">Races</span
      >
      <span v-if="isModeGP" id="tab-predictions" :class="selectedTabClass(2)" @click="predictions">Predictions</span
      >
    </nav>
    <!-- <i class="fa fa-stopwatch"></i>
    <i class="fa fa-chevron-right"></i>
    <i class="fa fa-person-running"></i>
    <i class="fa fa-ticket-simple"></i> -->
    <div class="main">
      <div id="container-leaderboard">
        <table id="table-leaderboard" cellpadding="0" cellspacing="0"></table>
      </div>
      <!-- <div id="container-member">
        <div id="member">
          Test
          <table id="table-test" cellpadding="0" cellspacing="0"></table>
        </div>
      </div> -->
      <div id="container-month">
        <div class="month-selector">
          <span
            :class="['action', minMonthClass]"
            id="month-prev"
            @click="prevMonth"
            ><i class="fa fa-chevron-left"></i
          ></span>
          <span id="month-name">Month</span>
          <span
            :class="['action', maxMonthClass]"
            id="month-next"
            @click="nextMonth"
            ><i class="fa fa-chevron-right"></i
          ></span>
        </div>
        <div class="race-name" id="race-name" v-show="isModeGP"></div>
        <table id="table-month" cellpadding="0" cellspacing="0"></table>
      </div>
      <div id="container-predictions">
        <div class="race-name" id="predictions-name"></div>
        <table id="table-predictions" cellpadding="0" cellspacing="0"></table>
      </div>
    </div>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue';
// import * as dataStore from './data-store.js';
import * as handicap from './lib/handicap';
import * as gp from './lib/gp';
import * as display from './lib/display.js';

export default {
  name: 'App',
  components: {
    // HelloWorld,
  },
  data() {
    return {
      screenWidth: 0,
      currentTab: 0,
      currentMode: 'handicap', // 0 Handicap - 1 GP
      currentYear: 2026,
      // table: document.getElementById('leaderboard'),
      isLoading: false,
      monthsLimit: [1, 1],
      currentMonth: 1,
      event: null,
      showRotate: false,
      version: 1.3
    };
  },
  mounted() {
    // console.log(`the component is now mounted.`);
    this.init();
    // this.leaderboard();
    // display.loading(true);
    // handicap.monthView(0);

    addEventListener('resize', (event) => {
      this.screenWidth = window.innerWidth;
      console.log('resize to:', this.screenWidth);
      this.updateView();
      // this.showRotate = this.screenWidth < 2600
    });
  },
  created() {
    // console.log('created');
  },
  computed: {
    minMonthClass() {
      return this.currentMonth == this.monthsLimit[0] ? 'disabled' : '';
    },
    maxMonthClass() {
      return this.currentMonth == this.monthsLimit[1] ? 'disabled' : '';
    },
    containerClass() {
      const event = this.currentMode;
      let tab = this.currentTab == 0 ? 'leaderboard' : (this.currentTab == 1 ? 'month' : 'predictions');
      const rotate = this.showRotate ? 'show-rotate' : ''
      return `${event} ${tab} ${rotate}`;
    },
    isModeGP() {
      return this.currentMode == 'gp'
    },
    rotateMessage() {
      return this.currentTab == 0 ? 'Rotate to see months' : 'Rotate to see detail'
    }
  },
  methods: {
    selectedTabClass(tabNo) {
      return this.currentTab == tabNo ? 'selected' : '';
    },
    init() {
      // handicap.loadData();
      // console.log(window.brcResults.mode)
      let params = new URLSearchParams(document.location.search);
      if (params.get("mode")) {
        this.currentMode = params.get('mode');
      } else if (window.brcResults.mode) {
        this.currentMode = window.brcResults.mode;
      } else {
        this.currentMode = 'handicap';
      }

      if (params.get("year")) {
        this.currentYear = params.get('year');
      } else if (window.brcResults.year) {
        this.currentYear = window.brcResults.year;
      } else {
        this.currentYear = 2026;
      }
      this.event = this.currentMode == 'gp' ? gp : handicap;
      this.screenWidth = window.innerWidth;
      console.log(
        `[BRC Results] Version:${this.version} | Mode: ${this.currentMode} | Year: ${this.currentYear} | Screenwidth: ${this.screenWidth}`
      );
      handicap.setCallback(this);
      gp.setCallback(this);
      // document.getElementById('tab-leaderboard').onclick =
      //   handicap.showLeaderboard(this.screenWidth);
      // document.getElementById('tab-month').onclick = handicap.showMonth(
      //   this.screenWidth
      // );
      // document.getElementById('tab-member').onclick = showMember;
      // const tabs = document.getElementsByClassName('tab-month');
      // for (let i = 0; i < tabs.length; i++) {
      //   tabs[i].addEventListener('click', (e) => {
      //     const monthNo = parseInt(e.target.getAttribute('data-monthno'));
      //     showMonth(monthNo);
      //   });
      // }
      // Month selector
      // document.getElementById('month-prev').onclick = () => monthView(-1);
      // document.getElementById('month-next').onclick = () => monthView(1);
      // handicap.loading(false);
      // window.setTimeout(() => {
      //   const head = document.head;
      //   const link = document.createElement("link");
      //   link.type = "text/css";
      //   link.rel = "stylesheet";
      //   link.href = "https://brcresultsapp.web.app/brc-results.css";
      //   head.appendChild(link);
      // }, 1000)
      this.updateView()
    },
    leaderboard() {
      this.currentTab = 0;
      this.isLoading = true;
      this.event.showLeaderboard(this.currentYear, this.screenWidth).then((value) => {
        this.monthsLimit[1] = value;
        this.currentMonth = value;
        this.isLoading = false;
      });
    },
    updateMonth(change) {
      const oldMonth = this.currentMonth;
      if (change) {
        this.monthView(change);
      } else {
        this.currentMonth = this.monthsLimit[1];
      }
      if (oldMonth != this.currentMonth) {
        this.showMonth();
      }
    },
    showMonth() {
      this.isLoading = true;
      this.event
        .showMonth(this.currentYear, this.currentMonth, this.screenWidth)
        .then((value) => {
          // this.monthsLimit[1] = value
          this.isLoading = false;
        });
    },
    onMonthSelect(monthNo) {
      if (
        monthNo >= this.monthsLimit[0] &&
        monthNo <= this.monthsLimit[1] &&
        (monthNo !== this.currentMonth || this.currentTab == 0)
      ) {
        this.currentMonth = monthNo;
        console.log(`onMonthSelect:${monthNo}`);
        this.races();
      }
    },
    races() {
      this.currentTab = 1;
      this.showMonth();
    },
    predictions() {
      this.currentTab = 2;
      this.isLoading = true;
      this.event.showPredictions(this.screenWidth).then((value) => {
        this.isLoading = false;
      });
    },
    prevMonth() {
      this.updateMonth(-1);
    },
    nextMonth() {
      this.updateMonth(1);
    },

    updateView() {
      if (this.currentTab == 0) {
        this.leaderboard();
      } else if (this.currentTab == 1) {
        this.isLoading = true;
        this.event
          .showMonth(this.currentYear, this.currentMonth, this.screenWidth)
          .then((value) => {
            // this.monthsLimit[1] = value
            this.isLoading = false;
          });
      } else if (this.currentTab == 2) {
        this.isLoading = true;
        this.event
          .showPredictions(this.screenWidth)
          .then((value) => {
            this.isLoading = false;
          });
      }
      this.showRotate = this.screenWidth < 600
      // this.showRotate = true
    },
    monthView(change) {
      this.currentMonth += change;
      if (this.currentMonth > this.monthsLimit[1]) {
        this.currentMonth = this.monthsLimit[1];
      }
      if (this.currentMonth < this.monthsLimit[0]) {
        this.currentMonth = this.monthsLimit[0];
      }
    },
  },
};
</script>

<style lang="scss">
@import './styles/main.scss';
</style>
